module.exports = __webpack_public_path__ + "img/sxx.b60265dc.png";